/* Publish by EComposer at 2026-09-25 14:23:24*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6ibwsf8017l"]=  window.__ectimmers["ecom-6ibwsf8017l"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-6ibwsf8017l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ibwsf8017l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lsj8c8z0sj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lsj8c8z0sj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xdr2chebjge').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xdr2chebjge', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tyzihcifzqj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tyzihcifzqj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s0741spy60s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s0741spy60s', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5nv9o8ifql"]=  window.__ectimmers["ecom-5nv9o8ifql"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-5nv9o8ifql').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5nv9o8ifql', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4hypcf2k93o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4hypcf2k93o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-enn1n8h6lg9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-enn1n8h6lg9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}